import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PromiseResult } from '../models/PromiseResult';
import { RestApi } from '../shared/apiUrls';
import { PaginationModel } from '../models/util.models';

@Injectable({
    providedIn: 'root'
})
export class LookupScreenService {
    constructor(private readonly http: HttpClient) { }
    private lookdetails;
    private selectedPatient;
    private lookTdetails;
    private lookCdetails;
    private savedetails;

    private lookDoctorsDetails;
    private selectedDoctor;

    setSelectedPatient(selectedPatient) {
        this.selectedPatient = selectedPatient;
    }
    getSelectedPatient(): any {
        return this.selectedPatient;
    }


    async getPatientDetails(p_guid:string,consultationId:string): Promise<any> {
        let p_details = await this.http
            .get<PromiseResult>(
                RestApi.Urls.PatientAccountApi + '/fetch/profile/'+p_guid+"/"+consultationId
            )
            .toPromise();
        return p_details;
    }



    async searchPersonalDetails(body2): Promise<any> {
        this.lookdetails = await this.http
            .post<PromiseResult>(
                RestApi.Urls.PatientAccountApi + 'Get/lookup',
                body2
            )
            .toPromise();
        return this.lookdetails;
    }

    async searchTransactionlDetails(patient_guid: string, query: PaginationModel): Promise<any> {
        const params = new HttpParams()
            .set('page_no', query.page_no.toString())
            .set('records_per_page', query.records_per_page.toString());
        this.lookTdetails = await this.http
            .get<PromiseResult>(
                RestApi.Urls.PatientAccountApi +
                'lookup/' + patient_guid + '/transactions',
                { params }
            )
            .toPromise();
        return this.lookTdetails;
    }

    async searchConsultationDetails(patient_guid: string): Promise<any> {
        //this.transactionDetailsUrl+guid;
        this.lookCdetails = await this.http
            .get<PromiseResult>(
                RestApi.Urls.PatientAccountApi +
                'lookup/' + patient_guid + '/consultations',
            )
            .toPromise();
        return this.lookCdetails;
    }

    async savePersonalDetails(body, patient_guid): Promise<boolean> {
        this.savedetails = await this.http
            .put<PromiseResult>(
                RestApi.Urls.PatientAccountApi +
                'Update/lookup/' +
                patient_guid,
                body
            )
            .toPromise();

        return this.savedetails.success;
    }

    public displayDetails(): PromiseResult {
        return this.lookdetails;
    }

    async searchDoctorsDetails(body2): Promise<boolean> {
        this.lookDoctorsDetails = await this.http
            .post<PromiseResult>(
                RestApi.Urls.DoctorsApi + 'Get/lookup',
                body2
            )
            .toPromise();
        if (this.lookDoctorsDetails.data.doctors.count){
            this.setSelectedDoctor(this.lookDoctorsDetails);
            return this.lookDoctorsDetails.success;
        }
        return false;
    }

    displayDoctorsDetails(): PromiseResult {
        return this.lookDoctorsDetails;
    }

    setSelectedDoctor(selectedDoctor) {
        this.selectedDoctor = selectedDoctor;
    }
    getSelectedDoctor(): any {
        return this.selectedDoctor;
    }
}
